<template>
  <p>Info</p>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentInfo'
}
</script>
